
import bizInfo from "../pages/bizInfo/bizInfo.vue";

import customerCheck from "../pages/customerCheck/customerCheck.vue";


import bizFlow from "../pages/bizFlow/bizFlow.vue";
import bizEntry from "../pages/bizEntry/bizEntry.vue";
import bizPage from "../pages/bizPage/bizPage.vue";
import businessList from "@old/pages/businessList";

import bizCheck from "../pages/bizCheck/bizCheck.vue";
import serviceTest from "../pages/serviceTest/test.vue";
import speedTest from "../pages/speedTest/speedTest";
import vuePdf from "@/components/common/vue-pdf";
import userLogin from "@/components/common/userLogin";
import unlockAccount from "../pages/unlockAccount/unlockAccount";

export default [{
  path: "/",
  redirect: "/userLogin"
}, {
  path: "/businessList",
  name: "businessList",
  component: businessList,
  meta: {
    name: "待办业务列表",
    autoHeight: false,
    requireAuth: true,
    allowAuth: "editAuth,witnessAuth,checkAuth",
    hideHomeBtn: true }
}, {
  path: "/unlockAccount",
  name: "unlockAccount",
  component: unlockAccount,
  meta: {
    name: "待办业务列表",
    autoHeight: false,
    requireAuth: true,
    allowAuth: "editAuth,witnessAuth,checkAuth" }
}, {
  path: "/vuePdf",
  name: "vuePdf",
  component: vuePdf,
  meta: {
    name: "vuePdf",
    requireAuth: true,
    allowAuth: "editAuth" }
}, {
  path: "/test",
  name: "test",
  component: serviceTest,
  meta: {
    name: "接口测试",
    leftOptions: {
      text: "返回首页",
      iconName: "home",
      event: "onBackHome"
    },
    useNavStep: false,
    useWhiteBoard: true,
    requireAuth: true,
    allowAuth: "editAuth" }
}, {
  path: "/userLogin",
  name: "userLogin",
  component: userLogin,
  props: true,
  meta: {
    name: "柜员登录",
    useNavStep: false,
    useWhiteBoard: false,
    hideHomeBtn: true }
}, {
  path: "/bizFlow/:busiCode/:userType/:nodeType",
  name: "bizFlow",
  component: bizFlow,
  props: true,
  meta: {
    name: "资料录入",
    leftOptions: {
      text: "返回首页",
      iconName: "home",
      event: "onBackHome"
    },
    requireAuth: true,
    allowAuth: "editAuth,witnessAuth,checkAuth",
    useNavStep: true,
    useWhiteBoard: true
  },
  children: [{
    path: "bizEntry/:pageNum",
    name: "bizEntry",
    component: bizEntry,
    props: true,
    meta: {
      name: "资料录入",
      leftOptions: {
        text: "返回首页",
        iconName: "home",
        event: "onBackHome"
      },
      requireAuth: true,
      allowAuth: "editAuth",
      useNavStep: true,
      useWhiteBoard: true
    }
  }, {
    path: "bizPage/:pageName",
    name: "bizPage",
    component: bizPage,
    props: true,
    meta: {
      name: "资料录入",
      leftOptions: {
        text: "返回首页",
        iconName: "home",
        event: "onBackHome"
      },
      requireAuth: true,
      allowAuth: "editAuth",
      useNavStep: true,
      useWhiteBoard: true
    }
  }]
}, {
  path: "/customerCheck/:busiCode/:userType",
  name: "customerCheck",
  component: customerCheck,
  props: true,
  meta: {
    name: "身份识别",
    leftOptions: {
      text: "返回首页",
      iconName: "home",
      event: "onBackHome"
    },
    requireAuth: true,
    allowAuth: "editAuth,witnessAuth,checkAuth" }
}, {
  path: "/bizCheck/:busiCode/:userType",
  name: "bizCheck",
  component: bizCheck,
  props: true,
  meta: {
    name: "资料录入",
    leftOptions: {
      text: "返回首页",
      iconName: "home",
      event: "onBackHome"
    },
    useWhiteBoard: false,
    requireAuth: true,
    allowAuth: "editAuth,witnessAuth,checkAuth" }
}, {
  path: "/speedTest",
  name: "speedTest",
  component: speedTest,
  props: true,
  meta: {
    name: "网速测试",
    leftOptions: {
      text: "返回首页",
      iconName: "home",
      event: "onBackHome"
    },
    useWhiteBoard: false,
    useNavStep: false
  }
}];


//////////////////
// WEBPACK FOOTER
// ./src/router/routers.js
// module id = 853
// module chunks = 2